import React from 'react'
import { Button } from '@pmi/pmi-iqos-ds-react'

const AddToCartButton = ({
  maxQty,
  hasStock,
  addToCartHandler,
  addToPreorderHandler,
  loading,
  addToCartLabel,
  addToPreorderLabel,
  addToPreorderLabelDisabled,
  fullWidth,
  outOfStockAction,
  'data-testing': dataTesting
}) => {
  const outOfStockActionDisabled = outOfStockAction && outOfStockAction === 'N'
  const shouldAddToCart = hasStock && maxQty
  return shouldAddToCart || addToPreorderHandler ? (
    <>
      <Button
        loading={loading}
        data-testing={
          (dataTesting && dataTesting + (shouldAddToCart ? '' : '_Preorder')) ||
          null
        }
        text={
          shouldAddToCart
            ? addToCartLabel
            : outOfStockActionDisabled
            ? addToPreorderLabelDisabled
            : addToPreorderLabel
        }
        fullWidth={fullWidth}
        onClickHandler={
          shouldAddToCart ? addToCartHandler : addToPreorderHandler
        }
        variant={
          shouldAddToCart
            ? Button.variants.primary
            : outOfStockActionDisabled
            ? Button.variants.primary
            : Button.variants.secondary
        }
        disabled={!shouldAddToCart && outOfStockActionDisabled}
      />
    </>
  ) : null
}

export default AddToCartButton
